import 'pages/frontend/main-content/_mainContent.scss'
import myPic from 'assets/profile.png'
// import myPic from 'assets/my_pic4 (1).png'
import myCV from 'assets/cv/Usman-Arif.pdf'
import Typewriter from 'typewriter-effect'
import { Link } from 'react-router-dom'
import { useStateContext } from 'context/StateContext'
import { Helmet } from 'react-helmet'

export default function Hero() {
  const { handleButtonSound, handleButtonSound1 } = useStateContext()

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Usman Arif</title>
        <meta name="description" content="Muhammad Usman Arif | Professional Web Developer" />
        <meta name="keywords" content="usmanarif, Muhammad Usman Arif, Full Stack Developer, MERN Stack" />
      </Helmet>

      <div id="hero-section" data-aos="fade-up">
        <div className="row w-100 m-0 align-items-center">

          {/* ── Left: Content ── */}
          <div className="col-12 col-lg-6 hero-content">
            <div className="hero-tag">Welcome to my portfolio</div>

            <h1>
              Hi, I'm{' '}
              <span className="gradient-text">Usman Arif</span>
            </h1>

            <div className="typewriter-row">
              <span className="tw-prefix">I'm a</span>
              <Typewriter
                options={{
                  strings: [
                    'Frontend Developer',
                    'Backend Developer',
                    'MERN Stack Dev',
                    'React Native Developer',
                    'Mobile App Developer',
                    'Firebase Developer',
                    'Problem Solver',
                  ],
                  autoStart: true,
                  loop: true,
                  delay: 35,
                  deleteSpeed: 40,
                  wrapperClassName: 'type-writer',
                  cursorClassName: 'type-writer-cursor',
                }}
              />
            </div>

            <p className="hero-bio">
              Full Stack Developer crafting sleek front-ends and powerful back-ends.
              Turning ideas into fast, scalable web apps with clean code and modern tech.
            </p>

            <div className="hero-actions">
              <a
                className="btn btn-accent"
                href={myCV}
                download="Usman-Arif.pdf"
                onClick={handleButtonSound}
              >
                Download CV
              </a>
              <Link
                className="btn btn-outline-accent"
                to="/contact"
                onClick={handleButtonSound1}
              >
                Contact Me
              </Link>
            </div>

            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">3+</span>
                <span className="stat-label">Years Exp.</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">10+</span>
                <span className="stat-label">Projects</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">5+</span>
                <span className="stat-label">Happy Clients</span>
              </div>
            </div>
          </div>

          {/* ── Right: Image ── */}
          <div className="col-12 col-lg-6 hero-image-col">
            <div className="image-wrapper">
              <div className="glow-bg" />
              <div className="outer-ring" />
              <div className="inner-ring">
                <img src={myPic} alt="Usman Arif" className="profile-img" />
              </div>

              <div className="tech-badge badge-react">
                <span className="badge-dot" />
                React &amp; Next.js
              </div>
              <div className="tech-badge badge-node">
                <span className="badge-dot" />
                Node.js
              </div>
              <div className="tech-badge badge-mern">
                <span className="badge-dot" />
                MERN Stack
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
